import React from "react";
import Layout from "../../components/organisms/Layout";
import DynamicComponent from "../../components/molecules/DynamicComponent";

import Storyblok, { useStoryblok } from "../../utils/storyblok";
import Shop from "../../components/templates/Shop";

export default function ShopPage({ story, preview, children, products }) {
  const enableBridge = true; // load the storyblok bridge everywhere
  // use the preview variable to enable the bridge only in preview mode
  // const enableBridge = preview;
  story = useStoryblok(story, enableBridge);

  return (
    <>
      <Layout>
        <Shop blok={story.content} products={products} />
      </Layout>
    </>
  );
}

export async function getStaticProps({ params, preview = false }) {
  let slug = "/shop";
  let sbParams = {
    version: "published", // or 'draft'
    resolve_relations: ["ShopItem.items"],
  };
  let productParams = {
    starts_with: "shop/product/",
    version: "published",
    per_page: 100,
    sort_by: "published_at:desc",
    resolve_relations: ["Product.type", "Product.category", "Product.color"],
  };
  if (preview) {
    sbParams.version = "draft";
    sbParams.cv = Date.now();
    productParams.version = "draft";
    productParams.cv = Date.now();
  }

  let { data } = await Storyblok.get(`cdn/stories/${slug}`, sbParams);
  let { data: productsData } = await Storyblok.get(`cdn/stories`, productParams);
  return {
    props: {
      story: data ? data.story : false,
      products: productsData.stories ? productsData.stories : null,
      preview,
    },
    revalidate: 10, // revalidate every 10 seconds
  };
}
